export default {
  getAllKits(state) {
    return state.allKits;
  },
  getKitSkus(state) {
    return state.skus;
  },
  getKitSummaryProducts(state) {
    return state.kitSummary;
  },
  getTotalSuggestedRetailPrice(state) {
    return state.totalSuggestedRetailPrice;
  },
  getTotalCOGS(state) {
    return state.totalCOGS;
  },
  getFinalRetailPrice(state) {
    return state.finalRetailPrice;
  },
  getPercentMargin(state) {
    return state.percentMargin;
  },
  getKitPackagingID(state) {
    return state.packaging;
  },
  getKitShipMethodID(state) {
    return state.shipMethod;
  },
  getKitPackagingId(state) {
    return state.newKit.packaging;
  },
  getKitShipMethodId(state) {
    return state.newKit.shipMethod;
  },
  getNewKitObject(state) {
    return state.newKit;
  },
  getNewKitSku(state) {
    return state.newKit.sku;
  },
  getProductToEdit(state) {
    return state.productToEdit;
  },
  getClonedKitSku(state) {
    return state.clonedKitSku;
  },

  getQuickEditStatus(state){
    return state.quickEditActive;
  }
};

